import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=19507623&scoped=true"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"
import style0 from "./Data.vue?vue&type=style&index=0&id=19507623&prod&scoped=true&lang=css"
import style1 from "./Data.vue?vue&type=style&index=1&id=19507623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19507623",
  null
  
)

export default component.exports